import { journeyCatalog } from "@seeing-maths/content-runtime";
import { useLearning } from "../learning/learning-context";

const LABELS = {
  hidden: "Not started",
  discovered: "Discovered",
  working: "Working",
  strong: "Strong",
  remembered: "Remembered",
} as const;

const EVIDENCE_LABELS: Record<string, string> = {
  intuition: "Spotting the structure",
  manipulation: "Trying the artifact",
  symbolic: "Using symbols",
  explanation: "Explaining why",
  transfer: "Opening a new door",
  retention: "Remembering later",
};

export function FieldbookPage() {
  const { projection } = useLearning();
  const journey = journeyCatalog[0];
  const concept = projection?.concepts[journey.id];
  const review = projection?.reviewQueue.find((item) => item.conceptId === journey.id);
  const evidence = concept?.evidence ?? {
    intuition: 0,
    manipulation: 0,
    symbolic: 0,
    explanation: 0,
    transfer: 0,
    retention: 0,
  };

  return (
    <main className="simple-page">
      <header className="simple-hero">
        <p className="page-kicker">THE FIELDBOOK</p>
        <h1>What your journey has shown.</h1>
        <p>The Fieldbook remembers the different ways you have explored, solved, and explained an idea.</p>
      </header>

      <section className="fieldbook-card card">
        <div className="fieldbook-title">
          <span className="fieldbook-glyph" aria-hidden="true">{journey.glyph}</span>
          <div>
            <p className="card-kicker">JOURNEY 01 · {journey.world}</p>
            <h2>{journey.title}</h2>
          </div>
          <span className="tag tag-sage fieldbook-state">{LABELS[concept?.visibleState ?? "hidden"]}</span>
        </div>
        <div className="evidence-grid">
          {Object.entries(evidence).map(([name, value]) => (
            <div className="evidence-item" key={name}>
              <div><span>{EVIDENCE_LABELS[name] ?? name}</span><strong>{Math.round(value * 10)}/10</strong></div>
              <div className="evidence-track"><span style={{ width: `${value * 100}%` }} /></div>
            </div>
          ))}
        </div>
        <div className="fieldbook-note">
          {review ? (
            <p>A fresh <strong>{review.variantId.replaceAll("-", " ")}</strong> challenge will be ready on {new Date(review.dueAt).toLocaleDateString()}.</p>
          ) : (
            <p>A fresh challenge will appear after you explain the idea and use it in a new puzzle.</p>
          )}
        </div>
      </section>
    </main>
  );
}
